import {
  ADD_GROUP_COURSE,
  ADD_GROUP_COURSE_SUCCESS,
  ADD_GROUP_COURSE_CLEAN,
  ADD_GROUP_COURSE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  groupCourse: {},
}

const GroupCourseAdd = (state = initialState, action) => {
  switch (action.type) {
    case ADD_GROUP_COURSE:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADD_GROUP_COURSE_SUCCESS:
      state = {
        ...state,
        groupCourse: action.payload.groupCourse,
        loading: false,
        done: true,
      }
      break
    case ADD_GROUP_COURSE_CLEAN:
      state = initialState
      break
    case ADD_GROUP_COURSE_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default GroupCourseAdd
